export default "__VITE_ASSET__Wxw9R0vu__"